import { apiSlice } from "../../app/api/apiSlice";

export const getMaxLoanAmountApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getMaxLoan: builder.mutation({
			query: () => ({
				url: `/api/v1/user/get_admin_configuration/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetMaxLoanMutation } = getMaxLoanAmountApiSlice;
